import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { apiGet, apiPost } from '../lib/api'
import { useDocument } from '../lib/queries'
import { useDocumentTabs } from '../lib/useDocumentTabs'
import { usePageTitle } from '../lib/usePageTitle'
import type { DocumentVersionDto } from '../lib/types'

export function DocumentVersions() {
  const { uuid, projectKey } = useParams<{ uuid: string; projectKey: string }>()
  const navigate = useNavigate()
  const qc = useQueryClient()
  const doc = useDocument(uuid)
  const tabs = useDocumentTabs()
  usePageTitle(doc.data?.title)
  useEffect(() => {
    if (doc.data) tabs.open({ uuid: doc.data.uuid, title: doc.data.title, projectKey })
  }, [doc.data?.uuid, doc.data?.title, projectKey])  // eslint-disable-line react-hooks/exhaustive-deps
  const versions = useQuery({
    queryKey: ['documents', uuid, 'versions'],
    queryFn: () => apiGet<DocumentVersionDto[]>(`/api/documents/${uuid}/versions`),
    enabled: !!uuid,
  })

  const restore = async (version: number) => {
    if (!uuid) return
    await apiPost(`/api/documents/${uuid}/versions/${version}/restore`, {})
    qc.invalidateQueries({ queryKey: ['documents', uuid] })
    navigate(`/d/${uuid}`)
  }

  return (
    <main className="split-main" style={{ flex: 1, padding: 24, overflow: 'auto' }}>
      <h1>{doc.data?.title ?? ' '} — Version history</h1>
      {(versions.data?.length ?? 0) === 0 && versions.isSuccess && <p style={{ color: 'var(--text-secondary)' }}>No versions yet.</p>}
      <table id="version-list" className="table" style={{ marginTop: 12 }}>
        <thead>
          <tr><th>v</th><th>Title</th><th>Change summary</th><th>Date</th><th></th></tr>
        </thead>
        <tbody>
          {versions.data?.map((v) => (
            <tr key={v.id} className="version-item" data-version={v.version}>
              <td>{v.version}</td>
              <td>{v.title}</td>
              <td>{v.changeSummary || ''}</td>
              <td>{new Date(v.createdAt).toLocaleString()}</td>
              <td><button className="btn btn-ghost btn-sm" onClick={() => restore(v.version)}>Restore</button></td>
            </tr>
          ))}
        </tbody>
      </table>
    </main>
  )
}
